import sortUtils from "@utils/sort.utils";
import { filter, defaults } from "lodash";

export default {
  populateId(tree) {
    tree.forEach((node) => {
      node.id = node.data.id;
      if (node.nodes && node.nodes.length > 0) {
        this.populateId(node.nodes);
      }
    });
    return tree;
  },
  processDataForResourceTagging: function (originalData) {
    var nodes = {};

    const sortConfig = [
      { field: "type", asc: true },
      { field: "indexNo", asc: true },
    ];
    sortUtils.sortObjects(originalData, sortConfig);

    return filter(originalData, function (obj) {
      var id = obj["id"],
        parentId = obj["parentNodeId"];

      // we will construct a map: node id -> node
      // also if its nodes list exists already, we will assign the list to it
      nodes[id] = defaults(obj, nodes[id], { nodes: [] });
      // if the parent node entry doesn't exist in the map yet,
      // initialize its parent node nodes list and then push the node into it later
      nodes[parentId] = nodes[parentId] || { nodes: [] };
      // if parentId is evaluated as false, second statement will not be executed
      // if parentId has value, then we will push the node into its parent nodes list
      parentId && nodes[parentId]["nodes"].push(obj);

      // only those nodes whose parent id is null will be returned, that means they are in root folder
      return !parentId;
    });
  },
  // addNodeStateToAllNonLeafNodes(nodes, status) {
  //   nodes.forEach(node => {
  //     if (node.nodes && node.nodes.length > 0) {
  //       node.state = status;
  //       this.addNodeStateToAllNonLeafNodes(node.nodes, status);
  //     }
  //   });
  // },
  constructTree(list, identifierKey = "id", parentKey = "parentId") {
    const nodes = {};
    return list.filter((obj) => {
      const id = obj[identifierKey];
      const parentId = obj[parentKey];

      // we will construct a map: node id -> node
      // also if its nodes list exists already, we will assign the list to it
      nodes[id] = defaults(obj, nodes[id], { nodes: [] });
      // if the parent node entry doesn't exist in the map yet,
      // initialize its parent node nodes list and then push the node into it later
      nodes[parentId] = nodes[parentId] || { nodes: [] };
      // if parentId is evaluated as false, second statement will not be executed
      // if parentId has value, then we will push the node into its parent nodes list
      parentId && nodes[parentId]["nodes"].push(obj);

      // only those nodes whose parent id is null will be returned, that means they are in root folder
      return !parentId;
    });
  },
  findTreeNode(nodes, id) {
    for (let i = 0; i < nodes.length; i++) {
      let child = nodes[i];
      if (child.id === id) {
        return {
          nodes: nodes, //siblings
          node: child,
          index: i,
        };
      }
      if (child.nodes && child.nodes.length !== 0) {
        let result = this.findTreeNode(child.nodes, id);
        if (result) {
          return result;
        }
      }
    }
    return null;
  },
  findTreeParentNode(nodes, id, parent = null) {
    for (let i = 0; i < nodes.length; i++) {
      let child = nodes[i];
      if (child.id === id) {
        return {
          parent: parent,
          node: child,
          index: i,
        };
      }
      if (child.nodes && child.nodes.length !== 0) {
        let result = this.findTreeParentNode(child.nodes, id, child);
        if (result) {
          return result;
        }
      }
    }
    return null;
  },
};
